import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core"
import { EnvironmentService } from "./environment.service";
import { FileSubmission } from "../_models/fileSubmission.model";
import { map } from "rxjs/internal/operators";


@Injectable({ providedIn: 'root' })

export class SubmissioService{
    filename: string;
    constructor(private http: HttpClient,
        private environmentService: EnvironmentService) {
        this.filename = "";
    }
    getSubmissionUrl(entryId : number){
        var options = { 
            headers: new HttpHeaders().append('Access-Control-Allow-Origin','*'),
        };
        var param = {
            id : entryId,
        }
        var url = `${this.environmentService.apiUrl}/Consultas/GetFileSubmission?id=${entryId}`
        return this.http.post(url, param, options)
        .pipe(
            map((fileSub: FileSubmission) => {
              return fileSub;
            })
          );
    }
}


